export default "__VITE_ASSET__C3vWbqvP__"